import { graphql, useStaticQuery } from "gatsby";
import { Navigation, NavigationItem } from "../types";

type page = { id: string; name: string; data: { url: string; title?: string } };
export type NavigationResult = {
  data: { navigationItems: NavigationItem[]; location: string };
};
export type useGetNavRes = { navItems: NavigationItem[] };
export type useGetNavProps = { location: string };

export function useGetNav({
  location,
}: useGetNavProps): useGetNavRes | undefined {
  const queryResult = useStaticQuery(query);

  //get all navigations
  const navigationArray: NavigationResult[] =
    queryResult.allBuilderNavigation.edges[0].node.results;

  //console.log("zz",queryResult, navigationArray)
  //get all pages for future lookup
  //const pages: page[] = queryResult.allBuilderModels.page;

  //filter the navigation by the passed in location prop
  const nav = navigationArray.find(
    (n) => n.data.location.toLowerCase() === location.toLowerCase()
  );

  if (!nav) return undefined;

  //get our nav items
  const navigationItems: NavigationItem[] = nav.data.navigationItems;

  //we will loop every nav item and submenu and see if a page has been referenced and if it has we will lookup the correct url
  const mappedNavItems = navigationItems.map((nav) => {
    //console.log("nav", nav);
    let navItem: NavigationItem = { ...nav };
    navItem.url = navItem.page?.value?.data?.url || navItem?.url || "/";
    navItem.label = navItem.label || navItem.page?.value?.name || "";

    //now basically do the same for sub navigation, and i'm going to be lazy and copy and paste code
    if (navItem.subNavigation && navItem.subNavigation?.listItems?.length > 0) {
      navItem.subNavigation.listItems.map((subNav) => {
        subNav.url = subNav.page?.value?.data?.url || subNav.url || "/";
        subNav.title = subNav.title || subNav?.page?.value?.name || "/";
        //console.log("page", subNav.page);
      });
    } else {
      navItem.subNavigation = undefined;
    }
    return navItem;
  });

  //console.log("mapped items", mappedNavItems);

  return { navItems: mappedNavItems };
}

export default useGetNav;

const query = graphql`
  query Navigation {
    allBuilderNavigation(
      filter: { id: { ne: "dummy" } }
    ) {
      edges {
        node {
          results {
            name
            data {
              location
              navigationItems {
                icon
                iconOnly
                label
                page {
                  value {
                    name
                    data {
                      url
                    }
                  }
                  model
                }
                subNavigation {
                  listItems {
                    iconOnly
                    title
                    url
                    page {
                      value {
                        name
                        data {
                          url
                        }
                      }
                    }
                  }
                }
                url
              }
            }
          }
        }
      }
    }
  }
`;
